import React, { FC, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import ImgGame from '@/shared/pictures/game.svg';
import ImgMenu from '@/shared/pictures/menu.svg';
import ImgRating from '@/shared/pictures/rating.svg';
import ImgTeam from '@/shared/pictures/team.svg';
import { observer } from 'mobx-react-lite';
import { TG } from '@/shared/api/api';


export const Menu:FC = observer(() => {
    const navigate = useNavigate();
    const location = useLocation();
    const locationDepth = location.pathname.split('/').filter((x)=>x !== '');

    useEffect(() => {
        if (!TG?.BackButton) return;

        const shouldShow = locationDepth.length > 1 || locationDepth[0] == 'forecast-set' || locationDepth[0] == 'team';

        const onNavigate = () =>{


            if(locationDepth[0] == 'forecast-set'){
                navigate('/menu/forecast');
                return;
            }
            if(locationDepth[1] == 'forecast'){
                navigate('/menu');
                return;
            }

            if(window.history.length > 2){
                navigate(-1);
            }else {
                navigate('/menu');
            }

        }

        const onBack = () =>  onNavigate();

        if (shouldShow) {
          TG.BackButton.show();
          TG.BackButton.onClick(onBack);
        } else {
          TG.BackButton.hide();
        }

        return () => {
          TG.BackButton.offClick(onBack);
        };
      }, [locationDepth, TG]);

    return (
        <div className={`menu ${ locationDepth[0] !== undefined && locationDepth[0] != 'forecast-set' ? 'depth' : ''} ${locationDepth[0] == 'forecast-set' ? 'none-shadow' : ''}`} >
            <div className='menu-items'>
                <Link to='/profile' className={`menu-item ${ locationDepth[0] == 'profile' ? 'active' : ''}`}>
                    <img src={ImgTeam} alt="profile" />
                    Профиль
                </Link>
                <Link to='/' className={`menu-item ${ locationDepth[0] == undefined ? 'active' : ''}`}>
                    <img src={ImgGame} alt="game" />
                    Игра
                </Link>
                <Link to='/menu' className={`menu-item ${ locationDepth[0] == 'menu' ? 'active' : ''}`}>
                    <img src={ImgMenu} alt="menu" />
                    Меню
                </Link>
                <Link to='/rating' className={`menu-item ${ locationDepth[0] == 'rating' ? 'active' : ''}`}>
                    <img src={ImgRating} alt="rating" />
                    Рейтинг
                </Link>
            </div>
        </div>
    );
});
